// extracted by mini-css-extract-plugin
export default {"rating":"eE-z","numberOfStars":"fE-z","count":"gE-z","barGraphSpacing":"hE-z","barGraph":"iE-z"};